import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toast"]

  connect() {
    this.autoDismissTimeout = setTimeout(() => {
      this.dismissAll()
    }, 5000)
  }

  disconnect() {
    if (this.autoDismissTimeout) {
      clearTimeout(this.autoDismissTimeout)
    }
  }

  dismiss(event) {
    const toast = event.currentTarget.closest("[data-flash-target='toast']")
    if (toast) {
      toast.style.transition = "opacity 0.3s, transform 0.3s"
      toast.style.opacity = "0"
      toast.style.transform = "translateX(100%)"
      setTimeout(() => toast.remove(), 300)
    }
  }

  dismissAll() {
    this.toastTargets.forEach((toast) => {
      toast.style.transition = "opacity 0.3s, transform 0.3s"
      toast.style.opacity = "0"
      toast.style.transform = "translateX(100%)"
      setTimeout(() => toast.remove(), 300)
    })
  }
}
